<div class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary text-center w-[100%] cursor-pointer"
    [id]="'pagemodule' + content.id" [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }" [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
    <div>
        <div class="text-center mb-4">
            @if (items[0].value.url) {
            <img [src]="items[0].value.url" class="w-[75px] h-[75px] object-cover rounded-full" />
            }
        </div>
        <div class="text-center text-md font-bold mb-2" [attr.style]="buildStyle('text', items[1].styles?.text)">
            {{ items[1].value.text }}
        </div>
        <div class="text-center text-md mb-5" [attr.style]="buildStyle('text', items[2].styles?.text)"
            [innerHTML]="items[2].value.text | lineBreak">
        </div>
        <div class="mb-3">
            <input type="text" [(ngModel)]="email" pInput class="w-[100%]" placeholder="Enter your email address" />
        </div>
        <div>
            <div (click)="subscribeNewsletter()"
                class="h-text-center p-[10px] border-2 border-solid mt-[5px] mb-[5px] bg-transparent cursor-pointer transition-opacity duration-200"
                [attr.style]="buildStyle('button', items[3].styles?.button)">
                <a [ngStyle]="{
            color: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            fontFamily: 'inherit',
            backgroundColor: 'inherit',
            textAlign: 'inherit',
          }" class="no-underline">{{ items[3].value.label }}</a>
            </div>
        </div>
    </div>
</div>